import React, { FC } from 'react';
import {useStoreon} from 'storeon/react';
import { State } from '@/interfaces';
import Modal403 from '../components/Modal403';
import {TYPE_USER} from '../const';

const CheckStaffUserLayout: FC<React.ReactNode> = ({ children }) => {
  const { currentUser } = useStoreon<State>('currentUser')
  return (
    <>
      {currentUser.status && currentUser.user_status === TYPE_USER.SUPERUSER || currentUser.user_status === TYPE_USER.STAFF || currentUser.user_status === TYPE_USER.VIEWER ?
        <>
          {children}
        </>
        :
        <Modal403 />
      }
    </>
  )
}

export default CheckStaffUserLayout;